import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import { Button, Col, DatePicker, Grid, Row } from 'antd'
import SelectStaff from '../../SelectStaff'
import CategorySelector from '../../categorySelector'
import DealSummary from '../DealSummary'
import SaleSummary from '../SaleSummary'
import FilterWrapper from './filter.style'

const { RangePicker } = DatePicker
const { useBreakpoint } = Grid

const Filter = ({ categorySelectorProps = {}, onChangeFilters = () => {} }) => {
  const [openModal, setOpenModal] = useState(false)
  const [openSaleSummaryModal, setOpenSaleSummaryModal] = useState(false)
  const [startDate, setStartDate] = useState(dayjs().subtract(10,'d').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'))
  const { i18n } = useTranslation('sales', 'deals')
  const screens = useBreakpoint()
  const isMobile = !screens.sm

  const onChangePicker = (value) => {
    setStartDate(value[0].format('YYYY-MM-DD'))
    setEndDate(value[1].format('YYYY-MM-DD'))

    onChangeFilters({ startDate: value[0].format('YYYY-MM-DD') || '', endDate: value[1].format('YYYY-MM-DD') })
  }

  const onChangeCategory = value => {
    onChangeFilters({ categoryId: value })
  }

  const summaryModals = (
    <>
      {openModal && (
        <DealSummary
          openModal={openModal}
          setOpenModal={setOpenModal} />
      )}
      {openSaleSummaryModal && (
        <SaleSummary
          openModal={openSaleSummaryModal}
          setOpenModal={setOpenSaleSummaryModal} />
      )}
    </>
  )

  if (isMobile) {
    return (
      <FilterWrapper className="mobile">
        <div className="mobile-row mobile-buttons">
          <Button type="primary" size="small"
            onClick={() => setOpenModal(!openModal)}>
            {i18n.t('deals:dealSummary')}
          </Button>
          <Button type="primary" size="small"
            onClick={() => setOpenSaleSummaryModal(!openSaleSummaryModal)}>
            {i18n.t('sales:salesSummary.summary')}
          </Button>
        </div>
        {summaryModals}
        <div className="mobile-row">
          <SelectStaff
            fullWidth
            onChange={value => onChangeFilters({ staffId: value || '' })} />
        </div>
        <div className="mobile-row">
          <CategorySelector
            onChange={onChangeCategory}
            style={{ width: '100%' }}
            {...categorySelectorProps} />
        </div>
        <div className="mobile-row">
          <RangePicker
            style={{ width: '100%' }}
            onChange={onChangePicker}
            defaultValue={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
          />
        </div>
      </FilterWrapper>
    )
  }

  return (
    <FilterWrapper>
      <Row className="row-style">
        <Col span={8} className="col-style">
          <Button type="primary"
            onClick={() => setOpenModal(!openModal)}>
            {i18n.t('deals:dealSummary')}
          </Button>
          <Button type="primary"
            onClick={() => setOpenSaleSummaryModal(!openSaleSummaryModal)}>
            {i18n.t('sales:salesSummary.summary')}
          </Button>
        </Col>
        <Col span={16} className="col-style align-right">
          {summaryModals}
          <SelectStaff onChange={value => onChangeFilters({ staffId: value || '' })} />
          <CategorySelector
            onChange={onChangeCategory}
            style={{ width: '220px' }}
            {...categorySelectorProps} />
          <RangePicker
              style={{ width: '250px' }}
              onChange={onChangePicker}
              defaultValue={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
          />
        </Col>
      </Row>
    </FilterWrapper>
  )
}

Filter.propTypes = {
  categorySelectorProps: PropTypes.object,
  onChangeFilters: PropTypes.func
}

export default Filter
